import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { PlatformToolEditor } from "@/components/admin/custom-tools/platform-tool-editor";
import { Link } from "@/core/lib/navigation";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/settings/custom-tools/$id")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  component: AdminPlatformToolPage,
});

function AdminPlatformToolPage() {
  const { id } = Route.useParams();
  return (
    <div className="flex flex-1 flex-col p-6">
      <div className="mx-auto w-full max-w-3xl space-y-6">
        <div className="space-y-3">
          <Link
            href="/settings"
            className="inline-flex items-center gap-1.5 text-muted-foreground text-sm underline-offset-4 hover:underline"
          >
            <ArrowLeftIcon className="size-4" />
            Back to settings
          </Link>
          <div className="space-y-1">
            <h1 className="font-bold text-2xl tracking-tight">Edit template tool</h1>
            <p className="text-muted-foreground text-sm">
              Build the fields and template. Once saved, this tool is available to every workspace
              under Generate › My tools.
            </p>
          </div>
        </div>
        <PlatformToolEditor id={id} />
      </div>
    </div>
  );
}
